import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TableModule } from "primeng/table";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { Popover, PopoverModule } from "primeng/popover";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-customer-account",
  templateUrl: "./customer-account.component.html",
  styleUrls: ["./customer-account.component.scss"],
  imports: [TableModule, CommonModule, PopoverModule, InputTextModule],
})
export class CustomerAccountComponent implements OnInit {
  public customerVendor$ = new Subject<string>();
  client = "";
  showSmallLoader = false;
  customerLists: ClientSearchList[] = [];
  isClientValid = false;
  customerBillToObject!: ClientSearchList;

  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];

  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Output() customerAccountEvent = new EventEmitter<string>();

  constructor(private _customerAccountService: CustomerAccountService) {}

  ngOnInit() {
    this.searchCustomerName();
  }

  logValidationErrors() {
    if (!this.client || this.client === "") {
      this.isClientValid = true;
    } else {
      this.isClientValid = false;
    }
  }

  searchCustomerName() {
    this.customerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.smallLoaderEvent.emit(true);
          }
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            this.customerLists = res.data;
          }
          this.smallLoaderEvent.emit(false);
        },
        error: () => {
          this.smallLoaderEvent.emit(false);
        },
      });
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    const target = event.target as HTMLInputElement;
    const keyEvent = event as KeyboardEvent;
    this.smallLoaderEvent.emit(true);
    if (keyEvent.key.toLowerCase() === "tab") {
      const countryValue = target?.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(countryValue)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerLists = res.data;
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
              //this.clearShipToEvent.emit();
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.client = event.clientAccount;
    this.customerBillToObject = event;
    if (event.clientAccount != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
    clientProspetToggle.hide();
    this.customerAccountEvent.emit(event.clientAccount);
  }

  onCustomerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    elt: HTMLElement
  ) {
    const target = event.target as HTMLInputElement;
    mydrop.show(event, elt);
    if (target?.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  patchValueInCustomerAccountField(clientObj: ClientSearchList) {
    this.client = clientObj.clientAccount;
  }
}
